const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M6.5 2.75A3.75 3.75 0 0 0 2.75 6.5v11a3.75 3.75 0 0 0 3.75 3.75h11a3.75 3.75 0 0 0 3.75-3.75v-11a3.75 3.75 0 0 0-3.75-3.75zM4.25 6.5A2.25 2.25 0 0 1 6.5 4.25h2v15.5h-2a2.25 2.25 0 0 1-2.25-2.25zM10 19.75h7.5a2.25 2.25 0 0 0 2.25-2.25v-11a2.25 2.25 0 0 0-2.25-2.25H10z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
